export const isFutureProgram = (startTime: any, endTime: any) => {
    const currentTime = Date.now();
    return startTime > currentTime && endTime > currentTime;
};
